import Vue from 'vue';
import NbWxOpen from '@tencent/nb-wx-open';
import spmList from '@/spm/spm-map.json';
import { queryMatch } from '@tencent/nb-h5-tools';

const nbData = queryMatch(window.location.href, 'nb-data');
let publicParams = {};
if (nbData) {
  try {
    publicParams = JSON.parse(decodeURIComponent(nbData));
  } catch (error) {
    console.log(error);
  }
}

Vue.use(NbWxOpen, {
  spmList,
  platformPageSpm: publicParams.chaos_cur_spm,
});
